import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import App from '../../App'
import Login from '../Login/Login'
import { connect } from 'react-redux'
import {
    retrieveEmployeeSapProfile,
    retrieveExecutorTeam,
    retrieveTokenFromMask,
    retrieveTokenFromSaml,
    reviveToken,
} from '../../../actions/session';
import isElectron from 'is-electron'
import AutoEnrollment from '../AutoEnrollment/AutoEnrollment'
import PasswordRecovery from "../PasswordRecovery/PasswordRecovery";

/*
 *  @Description:   Component that will read the token in order to render the login component or the application.
 */

const InitialComponent = ( props ) => {
    const { session, isNetworkAvailable } = props;
    const canConnect = isNetworkAvailable;
    const urlParams = new URLSearchParams ( window.location.search );

    useEffect( () => {
        const loginMask = urlParams.get ( 'mask' );
        const loginSaml = urlParams.get ( 'saml' );

        if ( loginMask !== null ) {
            props.retrieveTokenFromMask ( loginMask );
        }

        if ( loginSaml !== null ) {
            props.retrieveTokenFromSaml ( loginSaml );
        }

        let obj = {
            username: localStorage.getItem( 'username' ),
            token: localStorage.getItem( 'token' ),
            isEmployee: localStorage.getItem( 'isEmployee' ) === "true",
        }

        if ( process.env.REACT_APP_SEE_TICKETS === "1" ) {
            obj = {
                ...obj,
                userUUID: localStorage.getItem( 'userUUID' ),
                ticketingUUID: localStorage.getItem( 'ticketingUUID' ) || undefined,
                teamUUID: (session.canExecute || localStorage.getItem( "teamUUID" )) ? localStorage.getItem( 'teamUUID' ) : undefined,
                profileUUID: localStorage.getItem( 'profileUUID' ) || undefined,
            }
        }

        if ( obj.username &&
            obj.username !== "null" &&
            obj.token &&
            obj.token !== "null" ) {
            props.reviveToken( obj );
        }

        if ( process.env.REACT_APP_SEE_TICKETS === "1" &&
            obj.profileUUID &&
            obj.profileUUID !== "null" ) {
            props.retrieveEmployeeSapProfile( obj.profileUUID );
        }

        if ( process.env.REACT_APP_SEE_TICKETS === "1" && (session.canExecute || localStorage.getItem( "teamUUID" )) &&
            obj.userUUID &&
            obj.userUUID !== "null" ) {
            props.retrieveExecutorTeam( obj.userUUID );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    useEffect( () => {
        if ( process.env.REACT_APP_SEE_TICKETS === "1" ) {
            if ( session && session.profileUUID && session.profileUUID !== "null" ) {
                props.retrieveEmployeeSapProfile( session.profileUUID );
            }

            if ( session && session.userUUID && session.userUUID !== "null" ) {
                props.retrieveExecutorTeam( session.userUUID );
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ session.profileUUID, session.userUUID, session.user ] );

    if ( isElectron() ) {
        return (
            session && session.token ?
                <Route path="/" component={ App }/>
                :
                <Login/>
        )
    } else {
        if ( (session && session.token) || !canConnect ) {
            return (
                <Route path="/" component={ App }/>
            )
        } else {
            return (
                <Switch>
                    <Route exact path={ "/new_user" }>
                        <AutoEnrollment/>
                    </Route>
                    <Route path={ "/password_recovery/:hash?/:uid?/:timestamp?" }>
                        <PasswordRecovery/>
                    </Route>
                    <Route path="/">
                        <Login/>
                    </Route>
                </Switch>
            )
        }
    }

}

const mapStateToProps = ( state ) => ({
    session: state.session,
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable,
});

export default connect( mapStateToProps, {
    reviveToken,
    retrieveEmployeeSapProfile,
    retrieveExecutorTeam,
    retrieveTokenFromMask,
    retrieveTokenFromSaml
} )( InitialComponent );